// extracted by mini-css-extract-plugin
export default {"container":"GLoading-module_container_b60c7498","loading":"GLoading-module_loading_f06421e0"};